export const SET_SMART_BID_SETTINGS_LOADING = 'SET_SMART_BID_SETTINGS_LOADING'
export const SET_SMART_BID_SETTINGS_LOADED = 'SET_SMART_BID_SETTINGS_LOADED'
export const SET_SMART_BID_SETTINGS = 'SET_SMART_BID_SETTINGS'

export type SmartBidSettingAction =
    | SetSmartBidSettingsLoadingAction
    | SetSmartBidSettingsLoadedAction
    | SetSmartBidSettingsAction

export interface SmartBidSettingsState {
    loading: boolean
    loaded: boolean
    smartBidSettings: Models.SmartBidSetting[]
}

export interface SetSmartBidSettingsLoadingAction {
    type: typeof SET_SMART_BID_SETTINGS_LOADING
    loading: boolean
    receivedAt: number
}

export interface SetSmartBidSettingsLoadedAction {
    type: typeof SET_SMART_BID_SETTINGS_LOADED
    loaded: boolean
    receivedAt: number
}

export interface SetSmartBidSettingsAction {
    type: typeof SET_SMART_BID_SETTINGS
    smartBidSettings: Models.SmartBidSetting[]
    receivedAt: number
}
